/* @source catpaw @line_count 123 @branch feature/ywh-ones-89612040*/
<template>
  <BikeDialog
    v-model="config.visible"
    v-bind="config"
    confirmText="提交申请"
    @confirm="onConfirm"
    @close="onClose"
  >
    <mtd-form ref="appealForm" :model="form" :rules="rules" :label-width="80">
      <mtd-form-item label="申请原因" prop="appealReasonType" required>
        <BikeEnumSelect
          style="width: 100%;"
          v-model="form.appealReasonType"
          labelKey="name"
          valueKey="id"
          :options="appealReasonList"
        />
      </mtd-form-item>

      <mtd-form-item label="备注" prop="remark">
        <mtd-textarea
          style="width: 100%;"
          v-model.trim="form.remark"
          :maxlength="5000"
          :rows="4"
          show-word-limit
          placeholder="请填写，不超过5000字"
        />
      </mtd-form-item>
    </mtd-form>
  </BikeDialog>
</template>

<script>
export default {
  name: 'AppealDialog',
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      appealReasonList: [],
      form: {
        appealReasonType: '',
        remark: '',
      },
      rules: {
        appealReasonType: [
          { required: true, type: 'number', message: '请选择申请原因', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getAppealReasonList()
  },
  methods: {
    getAppealReasonList() {
      this.fetch.get('reconcileBill_appealReason').then(res => {
        this.appealReasonList = res.data || []
      })
    },

    onConfirm({ start, end }) {
      this.$refs.appealForm.validate(valid => {
        if (valid) {
          start()
          const params = {
            id: this.id,
            ...this.form,
          }
          this.fetch
            .post('reconcileBill_billAppeal', params)
            .then(() => {
              this.$mtd.message.success('提交成功！')
              this.$emit('update')
              this.onClose()
              end()
            })
            .catch(() => end())
        }
      })
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>
